<template>
  <WorkIcon
    v-bind="$props"
  >
    {{ '$wCircle' }}
  </WorkIcon>
</template>

<script>
import WorkIcon from '@/components/global_components/icon/WorkIcon';

export default {
  name: 'WorkDefaultTabIcon',
  components: { WorkIcon },
  props: { ...WorkIcon.props },
};
</script>
